<div id="c-landing-custom" class="c-landing" *ngIf="isLoaded"
     [ngClass]="{'brand-wtg' : network && network == 16, 'brand-geo' : network && network == 46}">
  <div class="container container-lg content-wrapper">
    <div class="content">
      <h2 [innerHtml]="this.content.Titolo"></h2>
      <p [innerHtml]="this.content.Testo"></p>
    </div>
    <div class="image">
      <img src="{{this.content.UrlImg}}" alt="Immagine offerta" />
      <div class="top" *ngIf="this.topLogo">
        <img src="{{this.topLogo}}" alt="Logo tour operator" />
      </div>
    </div>
  </div>
</div>

